module.exports = __webpack_public_path__ + "img/zhaf_03.608ed108.jpg";